export default "__VITE_ASSET__DgUsI2hD__"